import { styled } from '@mui/material';
import React from 'react';
import { BrandclubProductCard } from '../components/BrandclubProductCard/index.js';
import BrandclubLoading from '../components/BrandclubLoading/index.js';
import { ProductGrid } from './SearchResultsStyles.js';

var Container = styled('div')({});
var SearchProductGrid = function (_a) {
    var loading = _a.loading, products = _a.products, LinkComponent = _a.LinkComponent, containerWidthOverride = _a.containerWidthOverride, onShareClick = _a.onShareClick, children = _a.children;
    return (React.createElement(Container, null, loading ? (React.createElement(BrandclubLoading, { type: "productGrid" })) : (React.createElement(ProductGrid, { className: "grid", containerWidthOverride: containerWidthOverride },
        children,
        products.map(function (product, idx) {
            return (React.createElement(BrandclubProductCard, { className: "fullsize_responsive", LinkComponent: LinkComponent, onShareClick: function (e) { return onShareClick(e, product); }, key: idx, product: product }));
        })))));
};

export { SearchProductGrid as default };
//# sourceMappingURL=SearchProductGrid.js.map
